import axios from "axios";
import i18n from "i18next";
import { trackSession } from "@/lib/session";

// Default: the API lives next to the frontend (same origin, same base path).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || process.env.PUBLIC_URL || "";
export const API = `${BACKEND_URL}/api`;

export const STAFF_TOKEN_KEY = "penda_token";
const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(STAFF_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const STAFF_SESSION_EXPIRED = "penda:staff-session-expired";
trackSession(api, STAFF_TOKEN_KEY, () => window.dispatchEvent(new Event(STAFF_SESSION_EXPIRED)));

export function formatError(detail) {
  if (detail == null) return i18n.t("errors.generic");
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
